import { BASE_ERROR_CODES } from "@better-auth/core/error";
import { BetterFetchError } from "@better-fetch/fetch";

const emailNotVerifiedCode = BASE_ERROR_CODES.EMAIL_NOT_VERIFIED.code;
const fallbackMessage = "Ein unerwarteter Fehler ist aufgetreten.";

const getNestedField = (source: unknown, field: string): string | undefined => {
  if (source && typeof source === "object" && field in source) {
    const value = (source as Record<string, unknown>)[field];
    return typeof value === "string" ? value : undefined;
  }
  return undefined;
};

// better-auth may put structured error info in either `cause` or `error`
const getBetterAuthErrorBody = (error: BetterFetchError): unknown =>
  "cause" in error ? error.cause : error.error;

const getErrorCode = (error: unknown): string | undefined => {
  if (!(error instanceof BetterFetchError)) return undefined;
  const errorBody = getBetterAuthErrorBody(error);
  return getNestedField(errorBody, "code");
};

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof BetterFetchError) {
    const errorBody = getBetterAuthErrorBody(error);
    return (
      getNestedField(errorBody, "message") ??
      (error.statusText !== "" ? error.statusText : fallbackMessage)
    );
  }

  if (error instanceof Error) return error.message;

  return fallbackMessage;
};

export const isEmailNotVerifiedError = (error: unknown): boolean =>
  getErrorCode(error) === emailNotVerifiedCode;
